// extracted by css-extract-rspack-plugin
export default {"flexContainer":"sxzEh","selected":"ds2gp","flexContent":"CcR7s","resizeHandle":"CN8vu","resizing":"FJGdd"};